export const getIsNotProductionOrigin = () => {
  return /(localhost)|(http:\/\/)/.test(window.origin);
};
